import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us">
      <section className="about-header">
        <div className="container">
          <h1>About Us</h1>
          <p className="about-subtitle">Building bridges, preserving heritage, creating lasting bonds</p>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-text">
            <h2>Vision and Objective</h2>
            <p>
              The Association aims to create and promote a spirit of brotherhood, solidarity, and mutual assistance between members during happy and unhappy events that mark their lives.
            </p>
            <h3>But et Objectif</h3>
            <p>
              L'Association a pour objectif de créer et favoriser un esprit de fraternité, de solidarité, et d'assistance mutuelle entre les membres lors d'évènements heureux et malheureux qui marquent leur vie.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;